function defaultResolve(fieldSettings, values, repeatId, setFieldDirty, pivotRow, pivotColumn) {
	return {
		field: fieldSettings,
		values,
		repeatId,
		pivotRow,
		pivotColumn,
		setFieldDirty
	};
}

const fieldMap = {
	Date: {
		component: "date",
		props: {},
		resolve: defaultResolve
	},
	DateTime: {
		component: "date-time",
		props: {},
		resolve: defaultResolve
	},
	Time: {
		component: "time-field",
		props: {},
		resolve: defaultResolve
	},
	YearMonth: {
		component: "year-month",
		props: {},
		resolve: defaultResolve
	},
	Number: {
		component: "number",
		props: {},
		resolve: defaultResolve
	},
	Selection: {
		component: "simple-selection",
		pivotAs: "PreSelect",
		props: {},
		resolve: defaultResolve
	},
	PreSelect: {
		component: "pre-select",
		props: {},
		resolve: defaultResolve
	},
	EntitySelector: {
		component: "selection",
		pivotAs: "PreSelect",
		props: {},
		resolve: defaultResolve
	},
	EntityContactSelector: {
		component: "entity-contact-selector",
		props: {},
		resolve: defaultResolve
	},
	Tags: {
		component: "multi-select",
		props: {},
		resolve: defaultResolve
	},
	TextArea: {
		component: "text-area",
		props: {},
		resolve: defaultResolve
	},
	Boolean: {
		component: "bool",
		props: {},
		resolve: defaultResolve
	},
	Checkbox: {
		component: "checkbox",
		props: {},
		resolve: defaultResolve
	},
	Text: {
		component: "text",
		props: {},
		resolve: defaultResolve
	},
	StringMulti: {
		component: "string-multi",
		props: {},
		resolve: defaultResolve
	},
	SingleFile: {
		component: "file-upload",
		props: {},
		resolve: defaultResolve
	},
	ImageFile: {
		component: "image-upload",
		props: {},
		resolve: defaultResolve
	},
	Location: {
		component: "degree-minute",
		props: {},
		resolve: defaultResolve
	},
	Coordinate: {
		component: "coordinate",
		props: {},
		resolve: defaultResolve
	},
	Markdown: {
		component: "markdown",
		props: {},
		resolve: defaultResolve
	},
	ReadOnlyTextInput: {
		component: "read-only-text",
		props: {},
		resolve: defaultResolve
	},
	default: {
		component: "text",
		props: {},
		resolve(fieldSettings, values) {
			return defaultResolve(fieldSettings, values);
		}
	}
};

export default fieldMap;
